import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';

interface IProps {
  resourcePath: string;
}

let isI18nInitialized = false;

const InitialTranslation: React.FunctionComponent<IProps> = (props: IProps) => {
  if (!isI18nInitialized) {
    i18n
      .use(initReactI18next)
      .use(ChainedBackend)
      .init({
        backend: {
          backends: [LocalStorageBackend, HttpBackend],
          backendOptions: [
            {
              expirationTime: 24 * 60 * 60 * 1000,
            },
            {
              loadPath: props.resourcePath,
            },
          ],
        },
      });
    isI18nInitialized = true;
  }

  return null;
};

export default InitialTranslation;
